/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _Object$assign = require('babel-runtime/core-js/object/assign')['default'];

require('babel/polyfill');

var environment = ({
	development: {
		isProduction: false
	},
	production: {
		isProduction: true
	}
})[process.env.NODE_ENV || 'development'];

module.exports = _Object$assign({
	host: process.env.HOST || 'localhost',
	port: process.env.PORT,
	apiHost: process.env.APIHOST || 'localhost',
	apiPort: process.env.APIPORT,
	app: {
		title: 'Baltimore Brew',
		description: 'All the modern best practices in one example.',
		head: {
			titleTemplate: '%s | Baltimore Brew',
			meta: [{ name: 'description', content: 'Baltimore Brew is a daily online journal featuring independent reporting and informed commentary about greater Baltimore.' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'Baltimore Brew' }, { property: 'og:image', content: '../../../static/logo.png' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'Baltimore Brew' }, { property: 'og:description', content: 'Baltimore Brew is a daily online journal featuring independent reporting and informed commentary about greater Baltimore.' }, { property: 'og:card', content: 'summary' }, { property: 'og:site', content: '@baltimorebrew' }, { property: 'og:creator', content: '@baltimorebrew' }, { property: 'og:title', content: 'Baltimore Brew' }, { property: 'og:description', content: 'Baltimore Brew is a daily online journal featuring independent reporting and informed commentary about greater Baltimore.' }, { property: 'og:image', content: '../../../static/logo.png' }, { property: 'og:image:width', content: '200' }, { property: 'og:image:height', content: '200' }]
		}
	}

}, environment);
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/config.js
 ** module id = 696
 ** module chunks = 0
 **/